import { Button, Container, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
	heroContent: {
		padding: theme.spacing(8, 0, 6),
	},
}));

const HeroText = ({ heroTitle, heroContent, buttons, headingVariant }) => {
	const classes = useStyles();
    

	return (
		<Container maxWidth="lg" className={classes.heroContent}>
			{heroTitle && <Typography component="h1" variant={headingVariant || "h3"} align="left" gutterBottom>
				<strong> {heroTitle} </strong>
			</Typography>}
			{ heroContent && <Typography variant="body1" color="textPrimary" component="p">
				{heroContent}
			</Typography>}
			{buttons && (
				<Grid container spacing={4} style={{ marginTop: "16px" }}>
					<Grid item>
						<Button
							size="large"
							variant="contained"
							fullWidth
							style={{
								backgroundColor: "#2196f3",
								color: "white",
								textTransform: "initial",
							}}
						>
							Get Started
						</Button>
					</Grid>
					<Grid item>
						<Button
							size="large"
							variant="outlined"
							fullWidth
							style={{
								color: "#2196f3",
								borderColor: "#2196f3",
								textTransform: "initial",
							}}
						>
							Learn more
						</Button>
					</Grid>
				</Grid>
			)}
		</Container>
	);
};
export default HeroText;
